import script from "./TheSddsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheSddsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TheSddsHeader.vue?vue&type=style&index=0&id=1bbd3de5&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bbd3de5"]])

export default __exports__